// extracted by mini-css-extract-plugin
module.exports = {"container":"RuleParagraph_container__3-WCj","title":"RuleParagraph_title__2trbd","content":"RuleParagraph_content__2LQgA"};